import http from '@/services/http'

export default {
  getTourById (id) {
    return http.post(`/tour/id/${id}`, {
      referer: document.referrer
    })
  },
  getTourByDomain (id) {
    const data = {
      domain: window.location.hostname // e.g. 290birkdaleroad.com
    };

    if (id) {
      data['tourId'] = id;
    }

    return http.post('/domain/getbydomain', data);
  },
  getPortfolioByDomain () {
    return http.post('/tour/portfolio/domain', {
      domain: window.location.hostname // window.location.hostname // e.g. lavishlistings.com
    })
  }
}
